<template>
  <div class="animated fadeIn presupuesto-gastos-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Información del Presupuesto de Gastos">
            <b-form-group
              label="Periodo"
              label-for="periodo"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoMesNombre" 
                :options="meses" 
                :state="periodoValido"
                class="mb-3 select-fecha select-fecha-mes"
                @blur.native="validate">
                <template slot="first">
                  <option :value='null'>Seleccione un mes</option>
                  <!--<option :value='null' :disabled='Boolean(true)'>Seleccione un mes</option>-->
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoAnio" 
                :options="anios" 
                :state="periodoValido"
                class="mb-3 select-fecha select-fecha-anio"
                @blur.native="validate">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                  <!--<option :value="0" :disabled='Boolean(true)'>Seleccione un año</option>-->
                </template>
              </b-form-select>
              <b-form-invalid-feedback id="periodoFeedback">
                {{ periodoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>

          <b-card header="Renglones">
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes" 
                :items="renglones" 
                :fields="fields">
              <template v-slot:cell(importe)="data">
                <app-formatted-currency 
                  :id="data.item.id"
                  :importe="data.item.importe"
                  @actualizarImporte="actualizarImporte">
                </app-formatted-currency>
              </template>
            </b-table>

            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes totales"
                :items="totales" 
                :fields="totalesFields">
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
            </b-table>
          </b-card>

          <!-- <b-card header="Totales">
            <b-form-group
              label="Total"
              label-for="totalPresupuesto"
              :label-cols="1"
              horizontal>
              <b-form-input 
                id="totalPresupuesto"
                :value="totalPresupuesto | moneda" 
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card> -->
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import FormattedCurrency from '../shared/formattedCurrency.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength } from 'vuelidate/lib/validators';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoGastos/getField',
  mutationType: 'presupuestoGastos/updateField',
});

export default {
  name: 'PresupuestoGastosABM',
  components: {
    appABMButton: ABMButtons,
    appFormattedCurrency: FormattedCurrency,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      fields: [
        {
          key: 'presupuestoGastosConcepto',
          label: 'Concepto'
        },
        {
          key: 'importe',
          label: 'Importe',
          class: 'text-right'
        },
      ],

      totalesFields: [
        { key: 'blank_0'},
        { key: 'importe', class: "text-right"}
      ],

      meses: [],
      anios: [],
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'periodo',
      'periodoMesNombre',
      'periodoAnio',
      'observaciones',
      'renglones',
      'totalPresupuesto'
    ]),
    totales() {
      return [{
        importe: this.totalPresupuesto
      }];
    }
  },  
  created() {
    this.getDatosAdicionales();
    
    /* Validamos si estamos agregando/editando un presupuesto o duplicando uno existente */
    let dispatch = 'presupuestoGastos/inicializar';
    if (this.$route.name == 'PresupuestoGastosDuplicar') {
      dispatch = 'presupuestoGastos/duplicarPresupuesto';
    }

    let presupuestoGastosId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        presupuestoGastosId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch(dispatch, presupuestoGastosId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    getDatosAdicionales() {
      this.meses = this.getMeses();
      this.anios = this.getAniosPeriodo();
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      // if (campo == "descripcion" || validarTodos) {
      //   if (this.$v.descripcion.$error) {
      //     this.descripcionValida = false;
      //     if (!this.$v.descripcion.maxLength) {
      //       this.descripcionInvalidaMsj = 'La descripción de la PO del certificado sólo puede contener hasta 150 caracteres.';
      //     }
      //   } else {
      //     this.descripcionValida = null;
      //     this.descripcionInvalidaMsj = '';
      //   }
      // }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo puede contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let mes = this.getMesNumero(this.periodoMesNombre);
      let anio = parseInt(this.periodoAnio);

      if (!this.isValidDate(1, mes, anio))
      {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período del comprobante.';
        save = false;
      } else {
        this.periodoValido = null;
        this.periodoInvalidoMsj = '';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('presupuestoGastos/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: "PresupuestosGastos" });
    },
    actualizarImporte(params) {
      this.$store.dispatch('presupuestoGastos/actualizarImporte', params)
        .catch(error => this.showErrorMsj(error));
    },
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .presupuesto-gastos-abm .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }
  .presupuesto-gastos-abm .registro-ordenes table td[aria-colindex="1"] {
    width: 70%;
  }
  .presupuesto-gastos-abm .registro-ordenes table td[aria-colindex="2"] {
    width: 30%;
  }
  .presupuesto-gastos-abm .registro-ordenes table td input {
    width: 70%;
    left: 5%;
    margin: 0; 
    text-align: right;
    /* -moz-appearance:textfield; */
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
  }
  .presupuesto-gastos-abm .registro-ordenes table td input[type=number]::-webkit-inner-spin-button, 
  .presupuesto-gastos-abm .registro-ordenes table td input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }

  .presupuesto-gastos-abm .registro-ordenes.totales table {
    margin-bottom: 0;
  }
  .presupuesto-gastos-abm .registro-ordenes.totales table th {
    display: none;
  }
  .presupuesto-gastos-abm .registro-ordenes.totales table tr {
    font-size: 1.2em;
  }

</style>
